<template>
  <div class="player-message" v-if="comment">
    <img
      :src="icons.addComment"
      alt=""
      @click.prevent.stop="openDialog = true" />
    <v-dialog
      v-model="openDialog"
      content-class="player-modal player-message-modal"
      max-width="400px">
      <div class="player-modal-content">
        <h3 class="modal-title">
          <span
            class="modal-close"
            @click.prevent.stop="openDialog = false"></span>
          {{ playerName }}
        </h3>
        <div class="player-modal-body">
          {{ comment }}
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import constants from "@/constants.js"

export default {
  name: "ReadPlayerMessage",
  props: ["playerName", "comment"],
  data() {
    return {
      openDialog: false,
    }
  },

  computed: {
    icons() {
      return constants.icons
    },
  },
}
</script>

<style lang="sass" scoped>
@import '@/assets/sass/_variables.sass'
.player-message
  position: absolute
  top: 0
  right: 0
  width: 20px
  color: white

  img
    width: 100%
    height: auto
</style>
